import React from "react";
import { IconT } from "types/utils";

export default function ProposalStatusInProgressIcon({ height = "32", width = "32" }: IconT) {
  return (
    <svg width={width} height={height} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="16" cy="16" r="16" fill="#007ED9" />
      <path
        d="M17.8332 7.08001V10.8663C17.8332 11.3797 17.8332 11.6364 17.9331 11.8325C18.021 12.005 18.1612 12.1452 18.3337 12.2331C18.5298 12.333 18.7865 12.333 19.2998 12.333H23.0862M23.3332 14.1555V20.7663C23.3332 22.3065 23.3332 23.0766 23.0334 23.6648C22.7698 24.1823 22.3491 24.603 21.8316 24.8666C21.2434 25.1663 20.4733 25.1663 18.9332 25.1663H13.0665C11.5264 25.1663 10.7563 25.1663 10.168 24.8666C9.65058 24.603 9.22989 24.1823 8.96624 23.6648C8.6665 23.0766 8.6665 22.3065 8.6665 20.7663V11.233C8.6665 9.69286 8.6665 8.92279 8.96624 8.33453C9.22989 7.81709 9.65058 7.39639 10.168 7.13274C10.7563 6.83301 11.5264 6.83301 13.0665 6.83301H16.0106C16.6833 6.83301 17.0196 6.83301 17.3361 6.90899C17.6167 6.97636 17.8849 7.08747 18.131 7.23825C18.4085 7.40831 18.6463 7.64612 19.1219 8.12174L22.0444 11.0443C22.5201 11.5199 22.7579 11.7577 22.9279 12.0352C23.0787 12.2813 23.1898 12.5495 23.2572 12.8301C23.3332 13.1466 23.3332 13.4829 23.3332 14.1555Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
